<template>
  <div
    :class="[{'spl-radiobutton-group--invalid': invalid},
             {'spl-radiobutton-group--horizontal': horizontal},
             {'spl-radiobutton-group--toggle': toggle},
             {'spl-radiobutton-group--nomargin': nomargin},
             'spl-radiobutton-group']">
    <div
      v-for="(option, index) in options"
      :key="'radioButtonGroupOption' + index"
      class="spl-radiobutton-group__item">
      <label :class="{'spl-radiobutton-group__item__label-checked': option.value === radioModel}" class="spl-radiobutton-group__item__label">
        <input
          v-model="radioModel"
          :value="option.value"
          type="radio"
          class="spl-radiobutton">
        <span>{{ option.label }}</span>
      </label>
      <form-input
        v-if="option.input"
        :disabled="option.value !== radioModel"
        :name="option.input.name"
        :placeholder="option.input.placeholder" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormRadiobutton',
  props: [
    'horizontal',
    'toggle',
    'nomargin',
    'value',
    'options',
    'invalid'
  ],
  data () {
    return {
      radioModel: this.value
    }
  },
  watch: {
    value (newVal, oldVal) {
      this.radioModel = newVal
    },
    radioModel (newVal, oldVal) {
      this.$emit('radiobuttonChanged', newVal)
    }
  }
}
</script>

<style lang="scss">
    @import '../../variables.scss';

    .spl-radiobutton {
        background-color: #fff;
        border: 2px solid $lightYellowBorder;
        border-radius: 50%;
        cursor: pointer;
        height: 18px;
        margin: 0 4px 0 0;
        position: relative;
        transition: border-color $shortTransition ease-in-out;
        width: 18px;

        &:checked {
            border-color: $mainTextColor;

            &:after {
                background-color: $mainTextColor;
            }
        }
    }
    .spl-radiobutton-group {
        margin-bottom: $mainBottomMargin;

        &--nomargin {
            margin: 0;
        }
        &--horizontal {
            display: inline-block;
            margin-right: 50px;
        }
        &--horizontal &__item {
            display: inline-block;
            margin-right: 20px;
        }
        &--toggle &__item {
            &__label {
                color: $radioButtonToggleGrey;
                transition: color $shortTransition ease-in-out;

                &-checked {
                    color: $radioLabelText;
                }
            }
        }

        &--invalid {
          border-bottom: 1px solid $errorRed;
        }

        &__item {
            padding-top: 10px;
            position: relative;

            .spl-input {
                margin: 0 0 0 30px;
                position: absolute;
                top: 0;
                width: auto;

                @include mobile() {
                    margin: 10px 0 0 0;
                    position: relative;
                    width: 100%;
                }
            }
            &__label {
                color: $radioLabelText;
                cursor: pointer;
                display: inline-block;
                font-size: 14px;
                vertical-align: top;

                span {
                    vertical-align: top;
                    line-height: 17px;
                }
            }
        }
    }
</style>
